import { PlatformPage } from './PlatformPage'
import { StaffTab } from './tabs/StaffTab'

export function StaffPage() {
  return (
    <PlatformPage
      title="Staff"
      description="Bokapsys internal staff members and their platform roles."
    >
      <StaffTab />
    </PlatformPage>
  )
}
